// extracted by mini-css-extract-plugin
module.exports = {"accordion":"__accordion__jfrBb","closeIconClass":"__closeIconClass__Fdtv9"};